import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import InboxIcon from '@mui/icons-material/Inbox';
import { openInboxOptionsDialogDialogName, saveFormOptionsDialogName } from './const';
import { ChoiceDialogProps } from './types';
import MessageDialog from '10.quickConnect.app/components/shared/Dialogs/MessageDialog';
import { MessageDialogOption } from '10.quickConnect.app/components/shared/Dialogs/MessageDialog/types';

// Choix proposés en quittant une saisie modifiable
const SaveFormOptionsDialog = ({
  open,
  onClose,
  actionSaveInDraft,
  actionDiscard,
  actionDeleteFromInbox,
}: ChoiceDialogProps) => {
  const { t } = useTranslation(['forms', 'declaration']);

  const isInbox = !!actionDeleteFromInbox;
  const dialogName = isInbox ? openInboxOptionsDialogDialogName : saveFormOptionsDialogName;

  const discardOption: MessageDialogOption = isInbox
    ? {
        name: 'dialog-option-save-form-keep',
        label: t('qcapp_dialog_save_form_keep').toString(),
        icon: <InboxIcon />,
        onClick: actionDiscard,
      }
    : {
        name: 'dialog-option-save-form-discard',
        label: t('qcapp_dialog_save_form_discard').toString(),
        icon: <DeleteIcon />,
        onClick: actionDiscard,
      };
  // Saisie d'un élément de la boîte de réception : elle peut aussi y être supprimée
  const deleteFromInboxOptions: MessageDialogOption[] = actionDeleteFromInbox
    ? [
        {
          name: 'dialog-option-save-form-delete',
          label: t('qcapp_dialog_save_form_delete').toString(),
          icon: <DeleteIcon />,
          onClick: actionDeleteFromInbox,
        },
      ]
    : [];

  return (
    <MessageDialog
      name={dialogName}
      open={open}
      onClose={onClose}
      title={t('qcapp_dialog_save_form_message').toString()}
      options={[
        {
          name: 'dialog-option-save-form-draft',
          label: t('qcapp_dialog_save_form_draft').toString(),
          icon: <SaveIcon />,
          onClick: actionSaveInDraft,
        },
        discardOption,
        ...deleteFromInboxOptions,
      ]}
      closeLabel={t('qcapp_dialog_save_form_cancel').toString()}
    />
  );
};

export default observer(SaveFormOptionsDialog);
